<template>
  <div id="root">
    <div id="app" class="logged-in">
      <div id="nav" class="mobileRoomTopNav_3gjO3">
        <div class="content_1QLZB">
          <div class="right_1XMld">
            <h3 style="color:white;margin-right: 15px;font-weight: bold;" class="pageTitle_36g65">
              ادیت عکس
            </h3>
            <button @click="startTour()">
              <i class="fa fa-lightbulb-on" style="font-size: 15px;color:deepskyblue"/>
            </button>
          </div>
          <div :style="isMobile == true ? 'margin-left:20px;' : 'margin-left:30px'" class="left_3cl7J">
            <button @click="gotoMain()" class="p-button p-component tu-button btn-tertiary backBtn_U6DGe" type="button">
              <i class="fa-solid fa-arrow-left" style="font-size:20px;color:rgb(209, 208, 208)"></i>
            </button>
          </div>
        </div>
      </div>
      <div id="app-menu" :class="isModalKharid == true || isModalVersion == true ? 'custom' : ''">
        <div id="app-menu-content-wrapper">
          <div v-if="isLoading == false" id="app-menu-content" :style="isMobile == false ? 'margin-top: 26px' : ''">
            <div class="text-button2" style="padding:10px;margin-top:15px;border-radius:10px;">
                <div class="input-btns">
          <button data-intro='Hello step one!' class="camera-btn" @click="openCamera" :disabled="isLoading">
            <i class="fa fa-camera"></i> دوربین
          </button>
          <button class="gallery-btn" @click="openGallery" :disabled="isLoading">
            <i class="fa fa-image"></i> گالری
          </button>
          <input ref="fileInput" type="file" accept="image/*" @change="onFileChange" style="display:none" />
        <input ref="cameraInput" type="file" accept="image/*" capture="environment" @change="onFileChange" style="display:none" />
        </div>
            </div>
            <div v-if="imagePreview"
              :class="isMobile == true ? 'tool-card-background background-image GalleryImagePreviewM' : 'tool-card-background background-image GalleryImagePreviewD'"
              :style="{ backgroundImage: 'url(' + imagePreview + ')' }">
            </div>
            <div style="margin-top: 10px" class="text-button">

              <textarea autoresize autocomplete="off" type="text" v-on:keydown.enter="handleEnter" autofocus=""
                id="textarea-input" v-model="chatbox"
                style="padding:10px;text-align: start;unicode-bidi: plaintext;overflow-y: auto;resize: none;width:100%;height:100%;min-height:110px;line-height:25px;display:block;font-size:17px;font-family: IRANSansWeb;color:white;outline: none;"
                placeholder="📝 توضیحی از عکسی که میخوای بسازی اینجا بنویس، هر چقدر توضیحت کامل تر و با جزئیات بیشتری باشه، نتیجه بهتری میگیری." />
              <div class="quick-nav-item" style="background-color:#6153cc;display:flex;border-radius:15px;">
                <span  class="overflow2"
                  style="display:block;padding:7px;font-size:17px;font-family: IRANSansWeb;color:white;">
                 توضیحات
                </span>
                <div style="display:flex">
                  <span @click="gotoHistory()" style="font-size: 15px;display: flex;justify-items: center;margin: auto;justify-content: center;justify-self: center;font-weight: bold;font-family: IRANSansWeb;color: rgb(231, 231, 231);"><i data-v-5c325864="" class="fa-solid fa-clock-rotate-left" style="/* padding: 3px; */color: white;margin: auto;margin-left: 5px;"></i>تاریخچه</span>

                  <i @click="chatbox = ''" style="padding:15px;margin:auto;color:white" class="fa-solid fa-trash"></i>
                </div>
              </div>
            </div>
            

            <div v-if="selectedStyle != null" class="text-button2"
              style="padding:10px;margin-top:10px;border-radius:10px;">
              <div style="display:flex;justify-content:space-between">
                <div class="menu-section-title">
                  <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:rgb(231, 231, 231);">
                    <i style="margin-top:10px;padding:3px;color:white" class="fa-solid fa-check"></i>انتخاب شده: {{
                      this.selectedStyle.name }}</span>
                </div>
                <div class="menu-section-title" @click="deleteSelected()"
                  style="display:flex;padding:13px;cursor: pointer;">
                  <i style="color:rgb(255, 0, 0);font-size:20px;" class="fa-solid fa-x"></i>
                  <span
                    style="margin-right:8px;margin-top:-2px;font-size:15px;font-weight:bold;font-family: IRANSansWeb;color:rgb(255, 0, 0);">
                    حذف
                  </span>
                </div>

              </div>
              <div
                :class="isMobile == true ? 'tool-card-background background-image imageM' : 'tool-card-background background-image imageD'"
                :style="{ backgroundImage: 'url(' + this.selectedStyle.image + ')' }"></div>
            </div>
            <div id="tools-section" class="menu-section" style="margin-bottom:20px;padding-left: 5px;">
              <div style="display:flex;justify-content:space-between">
                <div class="menu-section-title">
                  <i class="fa-solid fa-envelope" aria-hidden="true"></i>
                  <span class="menu-section-title-text">سبک ها</span>
                </div>
                <div class="menu-section-title">
          <span @click="showStyleModal = true" class="menu-section-title-text text-button2"
            style="padding:10px;border-radius:10px;font-weight:200;font-size:1.0em;cursor: pointer;">مشاهده همه</span>
        </div>
              </div>
              <div class="scrollable-component menu-section-content" style="height: 100%;">
                <div v-for="style in styles" :key="style.id"
  @click="selectStyle(style.styleId, style.nameFa != '' ? style.nameFa : style.name, style.image1)" class="tool-card quick-nav-item style-card">
  <div class="tool-card-background background-image"
    :style="{ backgroundImage: 'url(' + style.image1 + ')' }">
    <div class="style-name style-name-overlay">{{ style.nameFa != null ? style.nameFa : style.name }}</div>
  </div>
</div>

              </div>
            </div>

            
            <div id="imageGen" v-if="isModalKharid == false && isModalVersion == false && isLoading == false" @click="generateImage()"
        class="circle-div"
        style="box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);cursor:pointer">

        <div style="position: relative;display: flex;justify-content: center;">
          <i style="color:white;font-size:22px;margin-left: 10px;" class="fa-regular fa-images"></i>
          <span style="line-height:20px;font-size:22px;font-weight:bold;font-family: IRANSansWeb;color:white"> ادیت عکس (20🍪) 
          </span>
      </div>
      </div>
          </div>
          <div v-else style=" height: 100vh;">
            <div
              :style="isMobile == true ? 'position: relative;top: 40%;-webkit-transform: translateY(-50%);-ms-transform: translateY(-50%);transform: translateY(-50%);' : 'position: relative;top: 40%;-webkit-transform: translateY(-50%);-ms-transform: translateY(-50%);transform: translateY(-50%);margin:auto;width:30vw'">
              <div style="vertical-align: middle;text-align: center;">
                <span style="font-size:20px;font-weight:bold;font-family: IRANSansWeb;color:white;">
                  در حال ادیت عکس شما ...
                </span>
              </div>

              <lottie :options="defaultOptions" style="margin-top:-40px;" v-on:animCreated="handleAnimation" />
              <div style="margin-top:-40px;vertical-align: middle;text-align: center;">
                <span style="font-size:17px;font-weight:bold;font-family: IRANSansWeb;color:white;">
                  این پروسه کمی زمانبر است، لطفا منتظر بمانید
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>     
      <PaywallABTest
        :isVisible="isModalKharid"
        :userCredit="credit"
        :totalCookies="10"
        triggerSource="EditImage"
        @close="isModalKharid = false"
        @activate="handlePaywallActivate"
      />
    </div>
    <StyleSelectorModal
      :visible="showStyleModal"
      @close="showStyleModal = false"
      @select="onStyleSelected"
    />
    <ImagePreviewModal 
    :visible="showImagePreviewModal" 
    :imageUrlProp="imagePreviewUrl" 
    :prompt="chatbox" 
    :styleName="selectedStyle != null ? selectedStyle.name : ''"
    @close="showImagePreviewModal = false"
    @useImage="this.useImage(this.imagePreviewUrl)" />
  </div>
</template>
<script>
/* eslint-disable */
import router from '@/router';
import axios from 'axios';
import Lottie from 'vue-lottie';
import * as animationData from '@/assets/img/test.json';
import PaywallABTest from '@/components/PaywallABTest.vue';
import { notify } from "@kyvg/vue3-notification";
import StyleSelectorModal from "@/components/StyleSelectorModal.vue";
import { ref, onMounted } from 'vue'
  import { useShepherd } from 'vue-shepherd'
  import ImagePreviewModal from "@/components/ImagePreviewModal.vue";

  const el = ref(null);

  const tour = useShepherd({
    useModalOverlay: true,
    
  });
var Timer;
export default {
  name: 'App',
  components: {
    'lottie': Lottie,
    StyleSelectorModal,
    ImagePreviewModal,
    PaywallABTest,
  },
  data() {
    return {
      defaultOptions: { animationData: animationData, autoplay: true },
      animationSpeed: 1,
      showStyleModal:false,
      anim: null,
      isModalKharid: false,
      isModalVersion: false,
      aiVersion: '',
      aiCodeVersion: 0,
      showNameDialog: false,
      name: "",
      isLoading: false,
      credit: 0,
      mobile: null,
      chosenName: "",
      selectedStyle: null,
      chatbox: "",
      texts: [],
      inputText: "",
      searchbox: "",
      styles: [],
      imagePreview: "",
      error: "",
      imageFile: "",
      showImagePreviewModal: false,
      imagePreviewUrl: "https://api.roboo.ir/content/EditStyles/test.png",
      isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
      isMobile: navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i) ? true : false,
      conversations: [

      ]
    };
  },
  methods: {
    gotoMain()
    {
      router.push("/")
    },
    startTour()
    {
      if(this.isLoading == false)
      tour.start();
    },
    useImage(url){
      this.showImagePreviewModal = false;

    },
    onStyleSelected(style) {
      console.log(style);
      var sname = style.nameFa != "" ? style.nameFa : style.name;
      console.log(sname);
      this.selectedStyle = {
        id: style.styleId,
        name: sname,
        image: style.image1,
      };
      localStorage.setItem("selectedEditStyleName", sname);
      localStorage.setItem("selectedEditStyleId", style.styleId);
      localStorage.setItem("selectedEditStyleImage", style.image1);
    },
    openGallery() {
        this.$refs.fileInput.click();
      },
      openCamera() {
        this.$refs.cameraInput.click();
      },
      onFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;
        this.imageFile = file;
        this.error = "";
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.imagePreview = ev.target.result;
        };
        reader.readAsDataURL(file);
        if(tour.isActive() == true)
        tour.next();
      },
    selectVersion(id) {
      this.isModalVersion = false;
      this.aiCodeVersion = id;
      localStorage.setItem("ImageAiVersion", id);
      if (id == 0)
        this.aiVersion = "Sdxl-Lightning";
      else if (id == 1)
        this.aiVersion = "Sdxl-Cascade";
      else if (id == 2)
        this.aiVersion = "Stable Diffusion XL";
      else if (id == 3)
        this.aiVersion = "Sdxl";
      else if (id == 4)
        this.aiVersion = "Dalle-3";
      else if (id == 5)
        this.aiVersion = "Dalle-3 XL";
      else if (id == 6)
        this.aiVersion = "Midjourney V6";
      else if (id == 7)
        this.aiVersion = "NijiJourney V5";
      else if (id == 8)
        this.aiVersion = "Animagine XL";
      else if (id == 9)
        this.aiVersion = "Dreamshaper-8";
      else if (id == 10)
        this.aiVersion = "AbsoluteReality";
    },
    gotoHistory() {
      router.push('/CreatedEditImage');
    },
    gotoPackages() {
      router.push('/packages');
    },
    handlePaywallActivate(data) {
      this.isModalKharid = false;
      if (data && data.package && data.period) {
        router.push({
          path: '/packages',
          query: {
            package: data.package,
            period: data.period
          }
        });
      } else {
        router.push('/packages');
      }
    },
    showReferral() {
      this.$emit("showReferral");
    },
    showAd() {
      notify({
        title: "روبو",
        text: "در حال اماده سازی ویدیو. لطفا منتظر بمانید!",
        type: "info"
      });
      this.isModalKharid = false;
      this.userInfo.credit = this.userInfo.credit + 3;
      this.$emit("setCredit");

      try {
        Android.ShowAdAdivery('8a4d6b52-0e81-4470-8755-c1e6e08806fa', "3");
        //Android.ShowAd('64b58b3c4bf57453cab34119',"3");
      }
      catch {
        try {
          Android.ShowAd('64b58b3c4bf57453cab34119', "3");
        }
        catch {
          Android.ShowAd('64b58b3c4bf57453cab34119');
        }
      }
    },
    randomPrompt() {
      const prmpt = this.prompts[Math.floor(Math.random() * this.prompts.length)];
      this.chatbox = prmpt;
    },
    selectStyle(id, name, image) {
      localStorage.setItem("selectedEditStyleName", name);
      localStorage.setItem("selectedEditStyleId", id);
      localStorage.setItem("selectedEditStyleImage", image);
      this.selectedStyle = { id, name, image };
      if(tour.isActive() == true)
      tour.next();
    },
    deleteSelected() {
      localStorage.removeItem("selectedEditStyleName");
      localStorage.removeItem("selectedEditStyleId");
      localStorage.removeItem("selectedEditStyleImage");
      this.selectedStyle = null;
    },
    handleEnter(event) {
      if (this.isMobile)
        return;
      if ((event.shiftKey && event.key === 'Enter')) {
        // Allow the default behavior of creating a new line on Android devices
        return;
      }

      event.preventDefault();
      this.generateImage();
    },
    gotoStyle(id) {
      router.push("/styles");
    },
    generateImage() {
      if(this.imageFile == "")
    {
      notify({
          title: "خطا",
          text: "لطفا یک عکس را انتخاب کنید.",
          type: "error"
        });
        return;
    }
      if (this.chatbox != "" || this.selectedStyle != null) {
        this.isLoading = true;
        let isFarsi = false;
        let char = new RegExp("[\u0600-\u06FF]");
        if (char.test(this.chatbox) === true) {
          isFarsi = true;
        }
        var styleId = '';
        if (this.selectedStyle != null) {
          styleId = this.selectedStyle.id
        }
        else
         styleId = 0;
        var form = new FormData;
        form.append("Token", localStorage.getItem("token"))
        form.append("Prompt", this.chatbox)
        form.append("ImageFile", this.imageFile)
        form.append("StyleId", styleId)
        
        axios.post("https://api.roboo.ir/api/image/editimage", form, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
          if (response.data.status == 0) {
            this.userInfo.credit = this.userInfo.credit - 20;
            this.$emit("setCredit");
            this.isLoading = false;
            this.imagePreviewUrl = response.data.message; // image link from response
              this.showImagePreviewModal = true;
              if(localStorage.getItem("onBoardingAction") == "")
    {
      setTimeout(()=>{
      this.$emit("showOnboardingPopup",3);
    },3000)
  }
          }
          else if (response.data.status == 2) {
            this.isLoading = false;
            this.istyping = false;
            this.isModalKharid = true;
            setTimeout(() => {
              window.scrollTo(0, 0);
            }
                , 5)
            return;
          }
          else {
            this.isLoading = false;
            notify({
              title: "خطا",
              text: response.data.message,
              type: "error"
            });
            return;
          }
        }).catch(r => {
          this.isLoading = false;
          notify({
            title: "خطا",
            text: "هنگام ارسال درخواست مشکلی پیش آمد \nوضعیت اینترنت خود را بررسی کنید",
            type: "error"
          });
          return;
        });

      }
      else {
        notify({
          title: "خطا",
          text: "لطفا متن یا یک استایل انتخاب کنید.",
          type: "error"
        });
      }
      tour.complete();
    },

    returnCharacterName(character) {
      if (character == "chat")
        return "روبو"
      else if (character == "moshaver")
        return "مشاور"
      else if (character == "mechanic")
        return "مکانیک"
      else if (character == "barnamenevis")
        return "برنامه نویس"
      else if (character == "translator")
        return "مترجم"
      else if (character == "teacher")
        return "معلم"

      else
        return "روبو"
    },
    getRandomStyles() {
      axios.get("https://api.roboo.ir/api/image/GetPageEditStyles")
        .then(response => {
          this.styles = response.data;
        });

    },
    tryToSearch() {
      clearTimeout(Timer);
      Timer = setTimeout(this.search, 1000);
    },
  },
  mounted() {
    var token = localStorage.getItem("token");
    if (this.isApplication) {
      Android.setToken(token);
    }
    if (localStorage.getItem("savedPrompt") != null) {
      this.chatbox = localStorage.getItem("savedPrompt");
      localStorage.removeItem("savedPrompt");
    }
    if (localStorage.getItem("ImageAiVersion") != null) {
      this.selectVersion(localStorage.getItem("ImageAiVersion"));
    }
    else {
      this.selectVersion(4);
    }
    if (localStorage.getItem("selectedEditStyleId") != null) {
      this.selectedStyle = { id: localStorage.getItem("selectedEditStyleId"), name: localStorage.getItem("selectedEditStyleName"), image: localStorage.getItem("selectedEditStyleImage") };
    }
    this.styles = [];
    this.getRandomStyles();
    var resizingTextareas = [].slice.call(document.querySelectorAll('textarea[autoresize]'));

    resizingTextareas.forEach(function (textarea) {
      textarea.addEventListener('input', autoresize, false);

    });
    function autoresize() {
      //findType(this)
      if (this.scrollHeight < 300 && this.scrollHeight > 57) {
        this.style.height = 'auto';
        this.style.height = this.scrollHeight + 'px';
      }
    }

    tour.addStep({
  id: 'step-1',
  title: 'مرحله ۱: انتخاب عکس',
  text: 'لطفاً یک عکس از گالری خود انتخاب کنید یا با دوربین عکس بگیرید.',
  attachTo: {
    element: '.text-button2',
    on: 'bottom'
  },
  buttons: [
    
    {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});

tour.addStep({
  id: 'step-2',
  title: 'مرحله ۲: وارد کردن متن دلخواه ',
  text: 'در این قسمت می‌توانید یک متن یا توضیح دلخواه وارد کنید تا در ادیت عکس استفاده شود.',
  attachTo: {
    element: '.text-button',
    on: 'top'
  },
  scrollTo :{behavior: 'smooth', block: 'end'},
  buttons: [
  {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});
tour.addStep({
  id: 'step-3',
  title: 'مرحله ۳: انتخاب سبک',
  text: 'یا میتوانید یکی از سبک‌های موجود را انتخاب کنید تا عکس شما با آن سبک ادیت شود.',
  attachTo: {
    element: '.scrollable-component',
    on: 'bottom'
  },
  scrollTo:true,
  buttons: [
  {
      text: 'بیخیال',
      action: tour.complete
    },
    {
      text: 'بعدی',
      action: tour.next
    },
    
  ]
});
tour.addStep({
  id: 'step-4',
  title: 'مرحله ۴: ادیت عکس',
  text: 'همه چیز آمادست! برای ادیت عکستون، روی دکمه «ادیت عکس» بزنید.',
  attachTo: {
    element: '#imageGen',
    on: 'top'
  },
  scrollTo:true,
  buttons: [
    {
      text: 'اتمام',
      action: tour.next
    }
    
  ]
});
if (localStorage.getItem("editImageTour") == null) {
      tour.start();
      localStorage.setItem("editImageTour","true");
}


  }
}
</script>
<style lang="scss" scoped>
@media (max-height: 600px) {
  .scrolling {
    height: 100%;
  }
}
.shepherd-footer {
  justify-content: space-between;
}
.background-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.GalleryImagePreviewM {
  position: relative;
  width: 90vw;
  height: 50vh;
  border-radius: 20px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;
}

.GalleryImagePreviewD {
  position: relative;
  width: 30vw;
  height: 30vw;
  border-radius: 20px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 20px;
}
.input-btns {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .camera-btn {
    background: var(--accent);
    color: #fff;
    border: none;
    border-radius: var(--radius);
    padding: 0.7rem 1.2rem;
    font-size: 1rem;
    font-weight: bold;
    box-shadow: var(--shadow);
    cursor: pointer;
    transition: background 0.2s;
  }
  .gallery-btn {
    background: var(--primary);
    color: #fff;
    border: none;
    border-radius: var(--radius);
    padding: 0.7rem 1.2rem;
    font-size: 1rem;
    font-weight: bold;
    box-shadow: var(--shadow);
    cursor: pointer;
    transition: background 0.2s;
  }
  
@media (max-height: 600px) {
  .scrollfix {
    margin-left: -5px;
  }
}

.custom {
  filter: blur(5px);
}

@media(min-width:768px) {
  .circle-div {
    background-color: #6153cc;
    height: 40px;
    width: 30vw;
    border-radius: 10px;
    bottom: 80px;
    right: 0;
    left: 0;
    margin: auto;
    display: flex;                // <-- Add this
    align-items: center;          // <-- Add this
    justify-content: center;      // <-- Add this
  }
}

@media(max-width:767px) {
  .circle-div {
    background-color: #6153cc;
    height: 60px;
    width: 90vw;
    border-radius: 10px;
    bottom: 80px;
    right: 20px;
    margin: auto;
    display: flex;                // <-- Add this
    align-items: center;          // <-- Add this
    justify-content: center;      // <-- Add this
  }
}

s::placeholder {
  color: rgb(185, 185, 185);
  opacity: 1;
  /* Firefox */
}

::-ms-input-placeholder {
  /* Edge 12 -18 */
  color: rgb(185, 185, 185);
}

@media(min-width:768px) {
  .login-box {
    top: 50%;
    left: 50%;
    width: 40vw;
    padding: 5px;
    transform: translate(-50%, -50%);
    z-index: 10000;
    background-color: rgb(24, 24, 24);
    box-sizing: border-box;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
    border-radius: 10px;

  }
}

@media(max-width:767px) {
  .login-box {
    top: 50%;
    left: 50%;
    width: 90vw;
    padding: 5px;
    transform: translate(-50%, -50%);
    z-index: 10000;
    background-color: rgb(24, 24, 24);
    box-sizing: border-box;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
    border-radius: 10px;

  }
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

span {
  font-family: IRANSansWeb;
  font-weight: bold;
}

@function gray($color) {
  @return rgb($color, $color, $color);
}

$red: rgb(239, 83, 80);
$orange: rgb(255, 160, 0);
$yellow: rgb(253, 216, 53);
$green: rgb(42, 252, 152);
$indigo: rgb(57, 73, 171);
$violet: rgb(103, 58, 183);

/* -- */

$blue: rgb(66, 165, 245);

@keyframes blink {

  from,
  25%,
  to {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(720deg);
  }

  to {
    transform: rotate(1440deg);
  }
}

@keyframes bounce {

  from,
  6.66%,
  17.66%,
  33.33% {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  13.33%,
  14.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  23.33% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  26.66% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  30% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
}

body {
  margin: 0px;
  overflow-x: hidden;
  padding: 0px;

  &::-webkit-scrollbar-track {
    background-color: gray(30);
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(white, 0.2);
    border-radius: 100px;
  }

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  input,
  h1,
  h3,
  a,
  span {
    color: gray(90);
    font-family: IRANSansWeb;
    font-weight: bold;
    font-weight: 400;
    margin: 0px;
    padding: 0px;
  }
}

$backgroundImage: "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2076&q=80";

.imageM {
  width: 75vw;
  height: 75vw;
  border-radius: 20px;
  margin: auto;
  margin-bottom: 20px
}

.imageD {
  width: 20vw;
  height: 20vw;
  border-radius: 20px;
  margin: auto;
  margin-bottom: 20px
}

.background-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.clear-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.1);
  border-radius: 100px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}

.text-button {
  backdrop-filter: blur(3px);
  background-color: rgba(white, 0.1);
  border-radius: 15px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

  &:hover {
    background-color: rgba(white, 0.2);
    border: 1px solid rgba(white, 0.3);
  }
}

.text-button2 {
  background-color: rgba(white, 0.1);

}

#app {
  background-color: gray(30);

  &.logged-out {
    #app-info {
      margin-left: 40px;
      opacity: 1;
      transform: translateX(0%);
    }

    #app-background {
      cursor: pointer;
    }

    #sign-in-button-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -40px);
    }
  }

  &.logging-in,
  &.verifying-log-in,
  &.log-in-error {
    #app-background {
      #app-background-image {
        filter: blur(8px);
        transform: scale(1.2);
      }
    }
  }

  &.logging-in,
  &.log-in-error {
    #app-pin-wrapper {
      opacity: 1;
      pointer-events: all;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  &.verifying-log-in {
    #app-loading-icon {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  &.log-in-error {
    #app-pin-wrapper {
      #app-pin {
        .app-pin-digit {
          background-color: rgba($red, 0.05);
          border-color: rgba($red, 0.5);
        }
      }
    }
  }

  &.logged-in {
    #app-menu {
      opacity: 1;
      pointer-events: all;
    }
  }

  .scrollable-component {
    cursor: grab;
    overflow: auto;
    user-select: none;
    width: 100%;

    &:active {
      cursor: grabbing;
    }

    &::-webkit-scrollbar {
      height: 0px;
      width: 0px;
    }
  }

  #app-loading-icon {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, 0%);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    i {
      animation: 2s spin ease-in-out infinite;
      color: white;
      font-size: 2em;
    }
  }

  #app-background {
    height: 100%;
    left: 0px;
    overflow: hidden;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 1;

    #app-background-image {
      height: 100%;
      transition: filter 250ms, transform 250ms;
      width: 100%;
    }
  }

  #app-info {
    bottom: 0px;
    left: 0px;
    margin: 40px;
    margin-left: 0px;
    opacity: 0;
    position: absolute;
    transform: translateX(-100%);
    transition: margin 250ms, opacity 250ms, transform 250ms;
    z-index: 2;
  }

  .user-status-button {
    cursor: pointer;
    margin-top: 10px;
    outline: none;
    padding: 10px;
    width: 100px;

    i {
      color: gray(245);
      font-size: 1.25em;
    }
  }

  #sign-in-button-wrapper {
    bottom: 0px;
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transform: translate(-50%, 40px);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #sign-in-button {
      &:not(:hover) {
        animation: bounce 3s infinite;
        animation-delay: 3s;
      }
    }
  }

  .info {
    align-items: flex-end;
    display: flex;

    .time {
      color: gray(245);
      font-size: 6em;
      height: 80px;
      line-height: 80px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);
    }

    .weather {
      display: inline-flex;
      height: 20px;
      margin-bottom: 6px;
      margin-left: 20px;

      i,
      span {
        align-items: center;
        display: inline-flex;
      }

      i {
        color: $yellow;
        font-size: 0.9em;
      }

      span {
        color: white;
      }

      .weather-type {
        height: 20px;
      }

      .weather-temperature-value {
        font-size: 1.5em;
        height: 20px;
        margin-left: 5px;
      }

      .weather-temperature-unit {
        align-items: flex-start;
        font-size: 0.8em;
        margin-left: 3px;
      }
    }
  }

  .reminder {
    display: flex;
    gap: 6px;
    margin-top: 10px;

    i,
    div {
      display: inline-flex;
    }

    i {
      color: gray(245);
      font-size: 0.8em;
      height: 12px;
      line-height: 12px;
    }

    span {
      color: rgba(white, 0.8);
      font-size: 1.1em;
    }

    .reminder-icon {
      align-items: center;
      height: 20px;
    }

    .reminder-time {
      align-items: flex-end;
      color: gray(30);
      font-size: 0.8em;
      height: 20px;
    }
  }

  #quick-nav {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    overflow: auto;
    padding-bottom: 5px;
    width: 100%;
    z-index: 3;

    .quick-nav-item {
      padding: 10px 20px;

      &:last-of-type {
        margin-right: 10px;
      }

      .quick-nav-item-label {
        color: gray(245);
        text-shadow: 0px 0px 2px rgba(black, 0.1);
      }
    }
  }

  #youtube-link {
    align-items: center;
    display: inline-flex;
    gap: 5px;
    margin-top: 10px;
    padding: 10px 20px;
    text-decoration: none;

    i,
    span {
      height: 20px;
      line-height: 20px;
    }

    i {
      color: $red;
    }

    span {
      color: white;
    }
  }

  .menu-section {
    margin-top: 20px;

    .menu-section-title {
      align-items: center;
      display: flex;
      gap: 6px;

      i,
      span {
        color: gray(245);
      }

      i {
        font-size: 1em;
      }

      .menu-section-title-text {
        color: rgba(white, 0.9);
        font-size: 1.4em;
        font-weight: bold;
      }
    }

    .menu-section-content {
      margin-top: 15px;
      padding-top: 5px;
    }
  }

  #restaurants-section {
    .menu-section-content {
      display: flex;
      gap: 1em;

      .restaurant-card {
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 14vw;
        max-height: 240px;
        position: relative;
        transition: transform 250ms;
        width: 25%;

        &:hover {
          transform: translateY(-5px);

          .restaurant-card-content {
            .restaurant-card-content-items {
              margin-bottom: 30px;
            }
          }
        }

        .restaurant-card-content {
          background: linear-gradient(to top, rgba(black, 0.8), transparent);
          border-radius: 10px;
          height: 100%;
          width: 100%;

          .restaurant-card-content-items {
            bottom: 0px;
            display: flex;
            flex-direction: column;
            margin: 20px;
            position: absolute;
            right: 0px;
            text-align: right;
            transition: margin 250ms;

            .restaurant-card-title {
              color: gray(245);
              font-size: 1.5em;
            }

            .restaurant-card-desc {
              color: $blue;
              font-size: 0.9em;
            }
          }
        }
      }
    }
  }
  .style-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  min-width: 120px;
  max-width: 180px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);

  .tool-card-background {
    position: relative;
    width: 100%;
    height: 120px;
    border-radius: 10px;
    overflow: hidden;
  }
  .style-name-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(30,30,30,0.7);
    color: #fff;
    font-size: 1.1em;
    font-family: IRANSansWeb, sans-serif;
    font-weight: bold;
    text-align: center;
    padding: 8px 0 6px 0;
    border-radius: 0 0 10px 10px;
    letter-spacing: 0.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .style-name {
    width: 100%;
    background: rgba(30,30,30,0.85);
    color: #fff;
    font-size: 1.1em;
    font-family: IRANSansWeb, sans-serif;
    font-weight: bold;
    text-align: center;
    padding: 8px 0 6px 0;
    border-radius: 0 0 10px 10px;
    letter-spacing: 0.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
  #weather-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      padding: 5px 0px;
      width: 100%;

      .day-card {
        backdrop-filter: blur(3px);
        background-color: rgba(white, 0.1);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        height: 8vw;
        max-height: 160px;
        min-height: 140px;
        min-width: 180px;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 7);

        &:last-of-type {
          margin-right: 5px;
        }

        .day-card-content {
          display: flex;
          flex-direction: column;
          height: calc(100% - 20px);
          justify-content: space-evenly;
          padding: 10px;

          i,
          span {
            color: gray(245);
            text-align: center;
          }

          .day-weather-temperature {
            align-items: flex-start;
            display: flex;
            font-size: 0.9em;
            justify-content: center;

            .day-weather-temperature-unit {
              font-size: 0.8em;
              margin-left: 3px;
            }
          }

          .day-weather-icon {
            font-size: 3.5em;
            text-shadow: 2px 2px 2px rgba(black, 0.1);

            &.sunny {
              color: $yellow;
            }

            &.rainy,
            &.stormy {
              color: $blue;
            }
          }

          .day-name {
            font-size: 0.9em;
            text-transform: uppercase;
          }
        }
      }
    }
  }

  #tools-section {
    .menu-section-content {
      display: flex;
      gap: 1em;
      width: 100%;
      height: 60vh;

      .tool-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: vw;
        max-height: 220px;
        min-height: 180px;
        min-width: 220px;

        position: relative;
        transition: transform 250ms;
        width: calc(100% / 6);

        &:hover {
          transform: translateY(-5px);

          .tool-card-background {
            filter: grayscale(0);
          }
        }

        .tool-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: filter 250ms;
          width: 100%;
        }

        .tool-card-content {
          display: flex;

          i,
          span {
            color: gray(245);
            position: absolute;
            width: 100%;
            height: 60%;

          }

          .tool-card-content-header {
            display: flex;
            flex-direction: column;
            gap: 2px;



          }

          .tool-card-icon {
            color: gray(245);
            font-size: 2em;
          }
        }
      }
    }
  }

  #movies-section {
    .menu-section-content {
      display: flex;
      gap: 1em;

      #movie-card-1 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($indigo, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-2 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($violet, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-3 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($red, 0.4), transparent, rgba(black, 0.4));
        }
      }

      #movie-card-4 {
        .movie-card-content {
          background: linear-gradient(to top, rgba($green, 0.4), rgba(black, 0.1), rgba(black, 0.4));
        }
      }

      .movie-card {
        background-color: gray(30);
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(black, 0.25);
        cursor: pointer;
        height: 40vw;
        max-height: 600px;
        min-height: 460px;
        min-width: 260px;
        overflow: hidden;
        position: relative;
        transition: transform 250ms;
        width: calc(100% / 4);

        &:hover {
          transform: translateY(-5px);

          .movie-card-background {
            transform: scale(1.05);
          }

          .movie-card-content {
            i {
              transform: translate(-20%, -20%) scale(1.2);
            }
          }
        }

        .movie-card-background {
          border-radius: 10px;
          height: 100%;
          left: 0px;
          position: absolute;
          top: 0px;
          transition: transform 250ms;
          width: 100%;
          z-index: 1;
        }

        .movie-card-content {
          background: linear-gradient(to top, rgba(black, 0.5), rgba(black, 0.1), rgba(black, 0.4));
          border-radius: 10px;
          height: 100%;
          position: relative;
          z-index: 2;

          .movie-card-info {
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 30px;

            span {
              text-shadow: 2px 2px 2px rgba(black, 0.1);
            }

            .movie-card-title {
              color: gray(245);
              font-size: 1.5em;
              font-weight: bold;
            }

            .movie-card-desc {
              color: gray(200);
              font-size: 0.9em;
            }
          }

          i {
            bottom: 0px;
            color: gray(245);
            font-size: 5em;
            padding: 30px;
            position: absolute;
            right: 0px;
            text-shadow: 2px 2px 2px rgba(black, 0.1);
            transition: transform 250ms;
          }
        }
      }
    }
  }

  #app-pin-wrapper {
    left: 50%;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -30%) scale(0.8);
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #app-pin-label {
      color: gray(245);
      font-size: 0.9em;
      margin: 10px;
      text-shadow: 2px 2px 2px rgba(black, 0.1);

      #app-pin-cancel-text {
        cursor: pointer;
        margin-left: 2px;

        &:hover {
          text-decoration: underline;
        }
      }

      #app-pin-error-text {
        color: $red;
      }
    }

    #app-pin-hidden-input {
      background-color: transparent;
      border: none;
      height: 0px;
      outline: none;
      pointer-events: none;
      position: absolute;
      width: 0px;
    }

    #app-pin {
      display: flex;
      gap: 10px;

      .app-pin-digit {
        align-items: center;
        background-color: rgba(white, 0.05);
        border: 1px solid rgba(white, 0.2);
        border-radius: 10px;
        box-shadow: 2px 2px 2px rgba(black, 0.06);
        display: inline-flex;
        font-size: 3em;
        height: 80px;
        justify-content: center;
        position: relative;
        transition: background-color 250ms, border-color 250ms;
        width: 60px;

        &:after,
        &:before {
          box-shadow: 2px 2px 2px rgba(black, 0.06);
          content: "";
          position: absolute;
          transition: opacity 250ms, transform 250ms;
          z-index: 2;
        }

        &:before {
          background-color: gray(245);
          border-radius: 10px;
          bottom: 0px;
          height: 3px;
          left: 15%;
          opacity: 0;
          transform: translateY(0px);
          width: 70%;
        }

        &:after {
          background-color: gray(245);
          border-radius: 20px;
          height: 20px;
          opacity: 0;
          transform: scale(0.25);
          width: 20px;
        }

        &.focused {
          &:before {
            animation: blink 2s ease-in-out infinite;
            opacity: 1;
            transform: translateY(-10px);
          }
        }

        &.hidden {
          &:after {
            opacity: 1;
            transform: scale(1);
          }

          .app-pin-digit-value {
            opacity: 0;
            transform: scale(0.25);
          }
        }

        .app-pin-digit-value {
          color: gray(245);
          transition: opacity 250ms, transform 250ms;
        }
      }
    }
  }

  #app-menu {
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    position: relative;
    transition: opacity 250ms, transform 250ms;
    z-index: 2;
    margin-top: 30px;

    #app-menu-content-wrapper {
      background: #212529;
      min-height: 80vh;
      padding: 80px;
      padding-top: 0px;

      #app-menu-content {
        margin: auto;
        max-width: 1600px;
        position: relative;

        #app-menu-content-header {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}

@media(max-width: 1300px) {
  #app {
    &.logged-out {
      #sign-in-button-wrapper {
        transform: translate(-40px, 0px);
      }
    }

    #sign-in-button-wrapper {
      bottom: 40px;
      left: auto;
      right: 0px;
      transform: translate(40px, 0px);
    }

    #app-menu {
      #app-menu-content-wrapper {
        padding: 20px;

        #app-menu-content {
          #restaurants-section {
            .menu-section-content {
              flex-wrap: wrap;

              .restaurant-card {
                height: 22vh;
                ;
                max-height: 300px;
                position: relative;
                width: calc(50% - 0.5em);
              }
            }
          }

          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 600px) {
  #app {
    .info {
      .time {
        font-size: 4em;
        height: 60px;
        line-height: 60px;
      }
    }

    .user-status-button {
      width: 60px;
    }

    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #restaurants-section {
            .menu-section-content {
              flex-direction: column;

              .restaurant-card {
                height: 40vw;
                position: relative;
                width: 100%;
              }
            }
          }

          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

@media(max-width: 400px) {
  #app {
    #app-menu {
      #app-menu-content-wrapper {
        #app-menu-content {
          #tools-section {
            .menu-section-content {

              .tool-card {
                width: 50vw;
              }
            }
          }
        }
      }
    }
  }
}

.overflow2 {
  margin: 0 0 0 0;
  text-overflow: ellipsis;
  width: 82vw;
  /**
   * Required properties to achieve text-overflow
   */
  white-space: nowrap;
  overflow: hidden;
}

.overflow {
  margin: 0 0 2em 0;
  text-overflow: ellipsis;
  /**
   * Required properties to achieve text-overflow
   */
  white-space: nowrap;
  overflow: hidden;
}
</style>